const LoyaltyTab = ({ loyalty, loading, summary, loyaltyDetails }) => {
  if (loading)
    return (
      <div className="cpv__tab-empty">
        <div className="cpv__spinner" />
      </div>
    );

  const points = summary?.loyaltyPoints || 0;
  const maxPoints = loyalty?.customerLoyaltyDto?.nextTierPoints || 2000;
  const tier = summary?.loyaltyPoints ?? "N/A";
  const badge = loyalty?.customerLoyaltyDto?.badge ?? null;
  const visitGap = loyalty?.customerLoyaltyDto?.visitGap ?? null;
  const progress = Math.min((points / maxPoints) * 100, 100);

  return (
    <div className="cpv__loyalty-wrap">
      <div className="cpv__loyalty-tier-card">
        <span className="cpv__ov-label">TIER PROGRESS</span>
        <div className="cpv__loyalty-tier-row">
          <span className="cpv__loyalty-tier-name">{tier}</span>
          {badge && <span className="cpv__loyalty-badge">{badge}</span>}
        </div>
        <span className="cpv__loyalty-pts">
          {points} / {maxPoints} points
        </span>
        <div className="cpv__loyalty-bar-bg">
          <div className="cpv__loyalty-bar-fill" style={{ width: `${progress}%` }} />
        </div>
      </div>
      <div className="cpv__loyalty-tier-card">
        <span className="cpv__ov-label">VISIT CADENCE</span>
        <div className="cpv__loyalty-tier-row">
          <span className="cpv__loyalty-tier-name">N/A</span>
          {/* {badge && <span className="cpv__loyalty-badge">{badge}</span>} */}
        </div>
        <span className="cpv__loyalty-pts">Average gap between repeat purchases</span>
      </div>


      {visitGap != null && (
        <div className="cpv__loyalty-visit-card">
          <span className="cpv__ov-label">VISIT CADENCE</span>
          <span className="cpv__loyalty-visit-days">{visitGap} days</span>
          <span className="cpv__ov-sub">Average gap between repeat purchases</span>
        </div>
      )}

      {loyaltyDetails && (
        <div className="cpv__loyalty-details-card">
          <p className="cpv__loyalty-details-title">CUSTOMER SUMMARY</p>
          <div className="cpv__loyalty-details-grid">
            <div className="cpv__loyalty-details-row">
              <span>Total Earned Points</span>
              <span className="cpv__loyalty-details-val">
                {loyaltyDetails?.totalEarnedPoint ?? 0}{" "}
                <span className="cpv__loyalty-details-subval">
                  (worth ₹{loyaltyDetails?.totalEarnedPointValue ?? 0})
                </span>
              </span>
            </div>
            <div className="cpv__loyalty-details-row">
              <span>Total Redeemed Points</span>
              <span className="cpv__loyalty-details-val">
                {loyaltyDetails?.totalRedeemedPoint ?? 0}{" "}
                <span className="cpv__loyalty-details-subval">
                  (worth ₹{loyaltyDetails?.totalRedeemedPointValue ?? 0})
                </span>
              </span>
            </div>
            <div className="cpv__loyalty-details-row">
              <span>Total Available Points</span>
              <span className="cpv__loyalty-details-val">
                {loyaltyDetails?.totalAvailablePoint ?? 0}{" "}
                <span className="cpv__loyalty-details-subval">
                  (worth ₹{loyaltyDetails?.totalAvailablePointValue ?? 0})
                </span>
              </span>
            </div>
            <div className="cpv__loyalty-details-row">
              <span>Total Expired Points</span>
              <span className="cpv__loyalty-details-val">
                {loyaltyDetails?.totalExpiredPoint ?? 0}{" "}
                <span className="cpv__loyalty-details-subval">
                  (worth ₹{loyaltyDetails?.totalExpiredPointValue ?? 0})
                </span>
              </span>
            </div>
            <div className="cpv__loyalty-details-row">
              <span>Total Cancelled Points</span>
              <span className="cpv__loyalty-details-val">
                {loyaltyDetails?.totalCancelledPoint ?? 0}{" "}
                <span className="cpv__loyalty-details-subval">
                  (worth ₹{loyaltyDetails?.totalCancelledPointValue ?? 0})
                </span>
              </span>
            </div>
          </div>
          <div className="cpv__loyalty-details-divider" />
          <div className="cpv__loyalty-details-footer">
            <span className="cpv__loyalty-details-footer-label">Total Available Points</span>
            <span className="cpv__loyalty-details-footer-val">
              {loyaltyDetails?.totalAvailablePoint ?? 0}{" "}
              <span className="cpv__loyalty-details-subval">
                (worth ₹{loyaltyDetails?.totalAvailablePointValue ?? 0})
              </span>
            </span>
          </div>
        </div>
      )}

      <div className="cpv__wallet-activity-card">
        <p className="cpv__wallet-activity-title">Wallet Activity</p>
        <div className="cpv__wallet-activity-list">
          <div
            className="cpv__wallet-activity-item"
            data-testid="card-wallet-activity-12-Apr,-2026"
          >
            <div>
              <p className="cpv__wallet-activity-item-title">App cashback</p>
              <p className="cpv__wallet-activity-item-subtitle">
                Date: 12 Apr, 2026 · Wallet update
              </p>
            </div>
            <div className="cpv__wallet-activity-item-right">
              <p
                className="cpv__wallet-activity-amount credit"
                data-testid="text-wallet-activity-amount-12-Apr,-2026"
              >
                N/A
              </p>
              {/* <span className="cpv__wallet-activity-badge credit">Credit</span> */}
            </div>
          </div>

          <div
            className="cpv__wallet-activity-item"
            data-testid="card-wallet-activity-06-Apr,-2026"
          >
            <div>
              <p className="cpv__wallet-activity-item-title">Coupon adjustment</p>
              <p className="cpv__wallet-activity-item-subtitle">
                Date: 06 Apr, 2026 · Wallet update
              </p>
            </div>
            <div className="cpv__wallet-activity-item-right">
              <p
                className="cpv__wallet-activity-amount credit"
                data-testid="text-wallet-activity-amount-06-Apr,-2026"
              >
                N/A
              </p>
              {/* <span className="cpv__wallet-activity-badge credit">Credit</span> */}
            </div>
          </div>

          <div
            className="cpv__wallet-activity-item"
            data-testid="card-wallet-activity-29-Mar,-2026"
          >
            <div>
              <p className="cpv__wallet-activity-item-title">Wallet redeemed</p>
              <p className="cpv__wallet-activity-item-subtitle">
                Date: 29 Mar, 2026 · Wallet update
              </p>
            </div>
            <div className="cpv__wallet-activity-item-right">
              <p
                className="cpv__wallet-activity-amount debit"
                data-testid="text-wallet-activity-amount-29-Mar,-2026"
              >
                N/A
              </p>
              {/* <span className="cpv__wallet-activity-badge debit">Debit</span> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyTab;
